import { useMemo } from 'react';

import { permittedFileTypesForOrg } from '../../../../../backend/src/matter/doc/allowed-extensions';
import { useUserContext } from '@/Contexts/User';

/** The file types the user's org may upload: allowedFileTypes minus flag-gated types (e.g. .pst) the org lacks. */
export function usePermittedFileTypes(): string[] {
  const { user } = useUserContext();
  const permissions = user?.organisation?.permissions;
  return useMemo(() => permittedFileTypesForOrg(permissions ?? []), [permissions]);
}
